import { RandomnessServiceCard } from '../../components/services/RandomnessServiceCard';
import shared from '../shared.module.css';
import styles from './RandomnessToolPage.module.css';

export function RandomnessToolPage() {
  return (
    <div className={shared.container}>
      <div className={shared.header}>
        <h1 className={shared.title}>VRF</h1>
        <p className={shared.subtitle}>
          Repo-backed view of Rivellum VRF primitives, SDK surfaces, and live chain observations
        </p>
      </div>

      <div className={styles.content}>
        <RandomnessServiceCard />

        <div className={styles.infoGrid}>
          <div className={shared.card}>
            <h3 className={shared.cardTitle}>🔒 Verifiable</h3>
            <p className={styles.cardText}>
              The VRF crate exposes public verification over deterministic input, output, and proof.
            </p>
          </div>
          
          <div className={shared.card}>
            <h3 className={shared.cardTitle}>🎲 Deterministic</h3>
            <p className={styles.cardText}>
              Host ABI semantics bind VRF derivation to height, transaction hash, contract, and call index.
            </p>
          </div>
          
          <div className={shared.card}>
            <h3 className={shared.cardTitle}>🧩 SDK Surface</h3>
            <p className={styles.cardText}>
              The SDK exposes getBeacon, u64, bytes, pickIndex, shuffleSmall, and raffleWinner.
            </p>
          </div>
          
          <div className={shared.card}>
            <h3 className={shared.cardTitle}>🔐 Post-Quantum</h3>
            <p className={styles.cardText}>
              The repo implements a Dilithium3-based VRF with BLAKE3 domain separation.
            </p>
          </div>
        </div>

        <div className={shared.card}>
          <h2 className={shared.cardTitle}>How It Works</h2>
          <p className={styles.cardText}>
            In this repo, randomness is modeled as a protocol primitive consumed by the SDK and by
            Mist host ABI syscalls. No public Rivellum network is currently running, so this page
            cannot show current height or receipt signals. Follow the links below for the implementation reference.
          </p>
        </div>
      </div>
    </div>
  );
}
